import React, { useDeferredValue, useEffect, useMemo, useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { deleteConfirmation, loadingConfirmation, sweetAlert, sweetAlertConfirmation } from "../../utils/index";
import DriversAddModal from './AddModal';
import { Button, Collapse } from "react-bootstrap";
import DriversViewodal from './ViewModal';
import { useGetDriverManageQuery, useRemoveDriverMutation, useResendInviteMutation, useUpdateManagementStatusMutation } from "../../redux/services/DriverService";
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { Link, useNavigate } from 'react-router-dom';
import DriverViewSide from './DriverSideView';
import MenuComponent from '../../components/MenuComponent';
import Filter from './Filter';
import MultiSelect from '../../components/MultiSelect';
import debounce from '../../utils/debounce';


const DriverManagementPage = () => {
    const navigate = useNavigate()

    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();


    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState(null)
    const params = useDeferredValue(query)



 const [searchText, setSearchText] = useState('');

   const debouncedSearch = useMemo(
    () =>
        debounce((value) => {
            handleSearchChange(value); 
        }, 500),
    []
);


    const handleSearchInput = (e) => {
        const value = e.target.value;
        setSearchText(value);
        debouncedSearch(value);
    };





    console.log('params', params)

    const [removeRequest] = useRemoveDriverMutation()
    const [inviteRequest] = useResendInviteMutation()

    const [updateStatus, { isLoading: isLoadinStatus }] = useUpdateManagementStatusMutation()

    const { data: data2, isLoading, isFetching, refetch } = useGetDriverManageQuery(`&page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}&employment_status=${params?.id ? params?.id : ''}`)
    const drivers = data2?.response?.data?.data?.filter(row => row?.employment_status != "1");
    const total = data2?.response?.data?.total;

    useEffect(() => {
        refetch()
    }, [])

    const handleView = (item) => {
        setIsEdit(item)
        setIsView(true)
    }
    const handleEdit = (item) => {
        setIsEdit(item)
        setIsShow(true)
    }
    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }
    const expiryColor = (date, currentDate) => {
        let expiryDate = new Date(date);
        let diff = expiryDate - currentDate;
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));

        switch (true) {
            case (days < 0):
                return <span className='badge bg-danger rounded-2 px-2'>{date}</span>;

            case (days >= 30):
                return <span className='badge bg-success rounded-2 px-2'>{date}</span>;

            case (days < 30 && days >= 21):
                return <span className='badge bg-info rounded-2 px-2'>{date}</span>;

            case (days < 21 && days >= 10):
                return <span className='badge bg-warning rounded-2 px-2'>{date}</span>;

            case (days < 10):
                return <span className='badge bg-danger rounded-2 px-2'>{date}</span>;

            default:
                return null; // Fallback case, if needed
        }
    };

    const statusColor = (status) => {
        switch (status) {
            case 0:
                return '#44b86c'
            case 1:
                return '#e82646'
            case 2:
                return '#f7b725'
            case 3:
                return '#17b1df'
            case 4:
                return '#17b1df'
            default:
                return 'black'
        }
    }


    const handleRemove = async (item) => {
        sweetAlertConfirmation()
            .then(async (result) => {
                if (result.isConfirmed) {
                    await removeRequest(item?.id)
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                sweetAlert(res?.message, 'success')
                                refetch()
                            }
                        })
                        .catch((err) => {
                            sweetAlert(err?.data?.message, 'error')
                        })
                }
            })
    }

    let data = [
        {
            driverId: 1,
            fullName: 'John Doe',
            email: 'john.doe@example.com',
            phoneNumber: '555-1234',
            dob: '1990-01-15',
            addressLine1: '123 Elm St',
            addressLine2: 'Apt 4B',
            city: 'New York',
            state: 'NY',
            country: 'USA',
            zipCode: '10001',
            dateCreated: '2023-01-01',
            employmentStatus: 'Active',
            documentStatus: 'Approved',
        },
        {
            driverId: 2,
            fullName: 'Jane Smith',
            email: 'jane.smith@example.com',
            phoneNumber: '555-5678',
            dob: '1985-05-20',
            addressLine1: '456 Maple Ave',
            addressLine2: 'Suite 2A',
            city: 'Los Angeles',
            state: 'CA',
            country: 'USA',
            zipCode: '90001',
            dateCreated: '2023-02-15',
            employmentStatus: 'On Leave',
            documentStatus: 'Revision',
        },
        {
            driverId: 3,
            fullName: 'Michael Johnson',
            email: 'michael.johnson@example.com',
            phoneNumber: '555-8765',
            dob: '1978-11-11',
            addressLine1: '789 Pine St',
            addressLine2: '',
            city: 'Chicago',
            state: 'IL',
            country: 'USA',
            zipCode: '60601',
            dateCreated: '2023-03-10',
            employmentStatus: 'Terminated',
            documentStatus: 'Approved',
        },
        {
            driverId: 4,
            fullName: 'Emily Davis',
            email: 'emily.davis@example.com',
            phoneNumber: '555-3456',
            dob: '1992-07-23',
            addressLine1: '321 Oak Ave',
            addressLine2: '',
            city: 'Houston',
            state: 'TX',
            country: 'USA',
            zipCode: '77001',
            dateCreated: '2023-04-05',
            employmentStatus: 'Active',
            documentStatus: 'Approved',
        },
        {
            driverId: 5,
            fullName: 'Robert Brown',
            email: 'robert.brown@example.com',
            phoneNumber: '555-9876',
            dob: '1988-09-09',
            addressLine1: '654 Cedar Rd',
            addressLine2: 'Unit 3',
            city: 'Phoenix',
            state: 'AZ',
            country: 'USA',
            zipCode: '85001',
            dateCreated: '2023-05-25',
            employmentStatus: 'On Leave',
            documentStatus: 'Approved',
        },
        {
            driverId: 6,
            fullName: 'Sarah Wilson',
            email: 'sarah.wilson@example.com',
            phoneNumber: '555-6543',
            dob: '1981-12-12',
            addressLine1: '987 Willow Ln',
            addressLine2: '',
            city: 'Philadelphia',
            state: 'PA',
            country: 'USA',
            zipCode: '19019',
            dateCreated: '2023-06-10',
            employmentStatus: 'Terminated',
            documentStatus: 'Revision',
        },
        {
            driverId: 7,
            fullName: 'James Williams',
            email: 'james.williams@example.com',
            phoneNumber: '555-4321',
            dob: '1994-03-03',
            addressLine1: '159 Birch St',
            addressLine2: 'Apt 5C',
            city: 'San Diego',
            state: 'CA',
            country: 'USA',
            zipCode: '92101',
            dateCreated: '2023-07-01',
            employmentStatus: 'Active',
            documentStatus: 'Approved',
        },
        {
            driverId: 8,
            fullName: 'Jessica Martinez',
            email: 'jessica.martinez@example.com',
            phoneNumber: '555-7654',
            dob: '1989-11-17',
            addressLine1: '753 Aspen Dr',
            addressLine2: '',
            city: 'Dallas',
            state: 'TX',
            country: 'USA',
            zipCode: '75201',
            dateCreated: '2023-08-18',
            employmentStatus: 'Active',
            documentStatus: 'Approved',
        },
        {
            driverId: 9,
            fullName: 'David Taylor',
            email: 'david.taylor@example.com',
            phoneNumber: '555-0987',
            dob: '1991-04-04',
            addressLine1: '147 Redwood St',
            addressLine2: 'Unit 6D',
            city: 'San Francisco',
            state: 'CA',
            country: 'USA',
            zipCode: '94101',
            dateCreated: '2023-09-03',
            employmentStatus: 'On Leave',
            documentStatus: 'Approved',
        },
        {
            driverId: 10,
            fullName: 'Linda Clark',
            email: 'linda.clark@example.com',
            phoneNumber: '555-3210',
            dob: '1983-02-28',
            addressLine1: '369 Palm St',
            addressLine2: '',
            city: 'Austin',
            state: 'TX',
            country: 'USA',
            zipCode: '73301',
            dateCreated: '2023-09-20',
            employmentStatus: 'Terminated',
            documentStatus: 'Revision',
        },
    ];


    return (
        <>
            <PageHeader name="Driver Qualifications" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex">
                                        <Link to="/drivers-management/archive" className="btn btn-primary">
                                            Archive
                                        </Link>
                                    </div>
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => refetch()}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary  "
                                            onClick={() => setOpen(!open)} // Toggle collapse
                                            aria-controls="collapse-inputs"
                                            aria-expanded={open}
                                        >
                                            <i className="ri-filter-2-fill" />
                                        </Button>
                                    </div>
                                    <div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                         <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchText}
                                                onChange={handleSearchInput}
                                            />
                                            <span className="input-group-text bg-transparent border text-primary">
                                                <i className="ri-search-line" />
                                            </span>
                                            {/* <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span> */}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="w-100">
                                    <Filter setQuery={setQuery} />
                                </div>
                            </Collapse >
                            <div className="card-body">
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={drivers}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            name: 'ID',
                                            selector: row => row?.id,
                                            sortable: true,
                                            width: '70px'
                                        },
                                        {
                                            selector: row => row.full_name,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('full_name')}
                                                >
                                                    {searchBy == 'full_name' ? <b className='text-success'>Driver Name</b> : 'Driver Name'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.email,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('email')}
                                                >
                                                    {searchBy == 'email' ? <b className='text-success'>Email</b> : 'Email'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.phone,
                                            sortable: true,
                                            name : (
                                                <span
                                                    onClick={() => handleSearchBy('phone')}
                                                >
                                                    {searchBy == 'phone' ? <b className='text-success'>Phone</b> : 'Phone'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'License Expiry',
                                            selector: row => expiryColor(row.expiration_date, new Date()),
                                            sortable: true,
                                            width: '150px'
                                        },
                                        {
                                            name: 'MVR Expiraty',
                                            selector: row => expiryColor(row.mvr_expiration_date, new Date()),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Medical Expiry',
                                            selector: row => expiryColor(row.exp_medical_examiner_date, new Date()),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Date of Last Drug Test',
                                            selector: row => expiryColor(row.last_drug_test, new Date()),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Employment Status',
                                            selector: row => (
                                                <>
                                                    {/* { title: 'Pending', id: 0 }, { title: 'Submitted', id: 1 }, */}
                                                    <MenuComponent
                                                        data={[{ title: 'Active', id: 0 }, { title: 'Terminated', id: 1 }, { title: 'Leave', id: 2 }]}
                                                        selectedData={row?.status?.title ? row?.status?.title : 'Select Status'}
                                                        selectdId={`${row?.employment_status}`}
                                                        color={statusColor(parseInt(row?.employment_status)) || 'black'}
                                                        update={updateStatus}
                                                        title={'Select Drive Management Status'}
                                                        isLoading={isLoadinStatus}
                                                        id={row?.id}
                                                        updateKey={'status'}
                                                    // refetch={refetch}
                                                    />
                                                </>
                                            ),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Document Status',
                                            selector: row => row.document_status == 3 && <span className='badge bg-primary py-1 rounded-2 px-2'>Approved</span>,
                                            sortable: true,
                                        },

                                        {
                                            name: 'Date Created',
                                            selector: row => row.created_at,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row, i) => {
                                                return (
                                                    <>
                                                        <div className="hstack gap-1 fs-1">
                                                            <button
                                                                aria-label="view"
                                                                onClick={() => loadingConfirmation(() => inviteRequest(row?.id), 'Inviting')}
                                                                className="btn btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                            >
                                                                Resend Invite
                                                            </button>
                                                            <Link
                                                                to={`/drivers/view/${row?.id}`}
                                                                state={{ alert: false }}
                                                                aria-label="View"
                                                                // onClick={() => handleView(row)}
                                                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-eye-line" />
                                                            </Link>
                                                            <button
                                                                aria-label="edit"
                                                                onClick={() => navigate(`/driver-aaplication/edit/${row?.id}`, { state: { isEdit: row } })}
                                                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-edit-line" />
                                                            </button>
                                                            <a
                                                                aria-label="anchor"
                                                                onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-delete-bin-7-line" />
                                                            </a>
                                                        </div>
                                                    </>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '220px'
                                        },
                                    ]}

                                />
                                {/* <DataTable
                                    paginationServer // Enable server-side pagination
                                    paginationTotalRows={total} // Total number of rows in the table
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page


                                    columns={columns}
                                    data={drivers}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                    progressPending={isFetching}
                                    progressComponent={<>
                                        <span className="loading d-flex align-items-center justify-content-center"
                                            style={{ height: 200 }}>
                                            <i className="ri-loader-2-fill fs-25 rotation"></i>
                                        </span>
                                    </>}
                                /> */}
                            </div>
                        </div >
                    </div >
                </div >
            </div >


            {isShow && (
                <DriversAddModal
                    show={isShow}
                    handleClose={() => setIsShow(false)}
                    isEdit={isEdit}
                />
            )}

            {/* <DriversEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            /> */}
            {
                isView && (
                    <DriversViewodal
                        show={isView}
                        handleClose={() => setIsView(false)}
                        isEdit={isEdit}
                    />
                )
            }

            {/* <DriverViewSide
                show={isView}
                close={() => setIsView(false)}
            /> */}
        </>
    );
};

export default DriverManagementPage;